import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { FaClock, FaCalendar } from 'react-icons/fa'
import { designTokens } from '@/styles/designTokens'

const ClockContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${designTokens.spacing.sm};
  width: 100%;
  height: 100%;
  justify-content: center;
  font-family: ${designTokens.typography.fontFamily.primary};
  padding: ${designTokens.spacing.lg};
`

const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  font-size: ${props => props.$compact ? designTokens.typography.fontSize['3xl'] : designTokens.typography.fontSize['4xl']};
  font-weight: ${designTokens.typography.fontWeight.bold};
  color: ${designTokens.colors.text.primary};
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
  font-variant-numeric: tabular-nums;
`

const DateDisplay = styled.div`
  display: flex;
  align-items: center;
  font-size: ${props => props.$compact ? designTokens.typography.fontSize.lg : designTokens.typography.fontSize['2xl']};
  color: ${designTokens.colors.text.secondary};
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  text-transform: capitalize;
  font-weight: ${designTokens.typography.fontWeight.medium};
`

const Clock = ({ time, date, compact = false }) => {
  // Validação para evitar "Invalid Date"
  const isValidTime = time && time !== 'Invalid Date' && time !== 'NaN:NaN:NaN'
  const isValidDate = date && date !== 'Invalid Date' && date !== 'NaN/NaN'

  return (
    <ClockContainer
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <TimeDisplay $compact={compact}>
        {isValidTime ? time : '00:00:00'}
      </TimeDisplay>
      <DateDisplay $compact={compact}>
        {isValidDate ? date : 'Carregando...'}
      </DateDisplay>
    </ClockContainer>
  )
}

export default Clock